import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import BoardListItem from '@board/components/List/BoardListItem.vue'
import WorkflowListItem from '@workflow/components/List/WorkflowListItem.vue'
import mailApi from '@mail/api'
import workflowApi from '@workflow/api'
import boardApi from '@board/api'
import * as calendarTypes from '@calendar/store/types'
import * as accountTypes from '@account/store/types'
import { uGetDate, uGetDateFormat } from '@appbase/util'
@Component({
    components: { PageHeaderWithActionBar, BoardListItem, WorkflowListItem },
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
            calendarList: calendarTypes.CALENDAR_DAILY_EVENT_LIST
        })
    },
    methods: {
        ...mapActions({
            loadCalendarList: calendarTypes.COMMON_DATE_SELECT_TODAY
        })
    }
})
export default class MainContainer extends Vue {

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    boardList: Array<article.Article> = []
    boardPageNum: number = 1
    boardId: number = (window as any).mainConfig.boardId
    workflowId: number = (window as any).mainConfig.workflowId
    workflowList: Array<workflow.RequestDocument> = []
    workflowCount: number = 0
    workflowDocumentPages: Array<workflow.TC_DOCUMENT_PAGES> = []
    mailCount?: number = 0

    hasUnreadMailFolder: any[] = []
    /*더보기 2023-05-23*/
    offset: number = 0
    pageNumber: number = 1
    pageSize: number = 20

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User
    calendarList!: calendar.CalendarItem[]

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadCalendarList!: () => void

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadBoardList() {
        var searchSet: article.SearchSet = {
            userCode: this.User.personCode,
            boardId: this.boardId,
            page: this.boardPageNum,
            itemsPerPage: 5,
            searchField: 0,
            searchFieldValue: null,
            prefaceId1: null,
            prefaceId2: null,
            sortField: 0,
            sortOrder: false,
            includeContent: false,
            useNotice: true
        }
        boardApi.article.getArticles(searchSet).then(async res => {
            if (res.data.length) {
                this.boardList = res.data
            } else {
                if (this.boardPageNum > 1) {
                    await(window as any).alertAsync(this.$t('마지막_페이지입니다').toString())
                    this.boardPageNum --
                }
            }
            
        })
    }

    loadWorkflowList() {
        var params = {
            documentQueryNumber: this.workflowId,
            personCode: this.User.personCode,
            deptCode: this.User.deptCode,
            apmStatus: null,
            applicationId: null,
            startDate: uGetDateFormat('yyyy-MM-DD' ,uGetDate(-1, new Date(), 'year')),
            endDate: uGetDateFormat('yyyy-MM-DD', new Date()),
            searchType: -1,
            searchValue: null,
            itemsPerPage: 5,
            page: 1,
            sortValue: this.pageItem?.searchSortValue || 4,
        };

        workflowApi.document.getDocumentList(params).then((res) => {
            this.workflowList = res
            this.workflowCount = res[0].totalCount
        })
    }

    async movePage(dir: string) {
        if (dir === 'prev') {
            if (this.boardPageNum > 1) {
                this.boardPageNum --
            } else {
                await(window as any).alertAsync(this.$t('첫번째_페이지입니다').toString())
            }
        } else {
            this.boardPageNum ++
        }

        this.loadBoardList()
    }

    getMailCount() {
        // mailApi.folder.getHasUnreadMailFolder().then((res: any) => {
        //     if (res.length) {
        //         this.mailCount = res.reduce((sum: any, x: { unreadCount: any }) => sum + x.unreadCount, 0)
        //     }
        // })

        var promiseArr: Promise<any>[] = [
            mailApi.folder.getFolderTree('')
        ]

        Promise.all(promiseArr).then(res => {
            this.hasUnreadMailFolder = res[0]['items']

            var folderId = ''
            for (var i = 0; i < this.hasUnreadMailFolder.length; i++) {
                var isDelete = false

                if(this.hasUnreadMailFolder[i]['name'] === '보낼 편지함' || this.hasUnreadMailFolder[i]['name'] === '임시 보관함' || this.hasUnreadMailFolder[i]['name'] === '정크 메일' ||this.hasUnreadMailFolder[i]['name'] === '지운 편지함')
                {
                    isDelete = true
                } 

                if(isDelete === true){
                    this.hasUnreadMailFolder.splice(i,1) 
                    i--

                }  else {
                    folderId += ',' + this.hasUnreadMailFolder[i]['id'] 
                }
            }

            if (this.hasUnreadMailFolder.length) {
                mailApi.mail.getUnreadMailList(folderId, this.pageSize, this.offset).then((res) => {
                    if(res.items.length) 
                    {
                        this.mailCount = Number(res.totalCount || 0) //총 개수 //총 개수
                    }
                })
            }
        })
    }

    getWorkflowDocumentPages() {
        workflowApi.common.getDocumentPages().then((res: any) => {
            this.workflowDocumentPages = res
        }).then(() => this.loadWorkflowList())
    }

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get calendarCount() {
        return this.calendarList.length
    }

    get pageItem() {
        var item = this.workflowDocumentPages?.filter((x) => x.no == Number(this.workflowId))[0]
        if (item) {
            return item
        }
        return null
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.loadBoardList()
        this.getWorkflowDocumentPages()
        this.getMailCount()
        this.loadCalendarList()
    }
}
